import React, { useState } from "react";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import { Spa } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAssistantStore } from "../../../stores/assistant";
import { BetaFeatureChip } from "../../../shared-components/BetaFeature";
import { ActionCard } from "../../../shared-components/ActionCards";
import { ReplaceConversationDialog } from "./ReplaceConversationDialog";

export const CreateWithBudButton = ({
  kind,
  classId,
  assignment,
  assignmentQuestion,
  details = {},
  children,
  unsaved = false,
  asCard = false,
  onOpened,
}) => {
  const [replace, setReplace] = useState(false);
  const navigate = useNavigate();
  const mobile = useMediaQuery(useTheme().breakpoints.down("sm"));
  const context = {
    class_id: classId || details.schoolClass?.id || assignment?.schoolClass?.id,
    assignment_id: assignment?.id,
    class_name: details.schoolClass?.name || assignment?.schoolClass?.name,
    creation: {
      kind,
      name: details.name || "",
      topic: details.context || details.description || "",
      due_date: details.dueDate?.format?.("YYYY-MM-DD") || "",
      source_question_id: assignmentQuestion?.id,
    },
  };
  const open = (confirmed = false) => {
    const store = useAssistantStore.getState();
    if (!confirmed && store.isEmbeddedOpen) {
      setReplace(true);
      return;
    }
    if (
      mobile &&
      unsaved &&
      !window.confirm("Open Bud? Unsaved changes on this page will be lost.")
    )
      return;
    store.replaceEmbedded(context, assignment?.name, context.class_name);
    if (mobile) {
      store.setFullPageLaunch(context);
      store.closeEmbedded();
      navigate(`/assistant?new=true&create=${kind}`);
    }
    setReplace(false);
    onOpened?.();
  };
  return (
    <>
      {asCard ? (
        <ActionCard
          iconName="UseAI"
          title="Create with Bud"
          titleAdornment={<BetaFeatureChip sx={{ ml: 1 }} />}
          subtitle={`Describe your ${kind} and let Bud prepare a draft for you to review before publishing.`}
          onAdd={() => open()}
        />
      ) : (
        <Button startIcon={<Spa />} variant="outlined" onClick={() => open()}>
          {children || "Use Bud to create"}
        </Button>
      )}
      <ReplaceConversationDialog
        open={replace}
        onClose={() => setReplace(false)}
        onConfirm={() => open(true)}
      />
    </>
  );
};
